import React from "react";
import { Segment, Table } from "semantic-ui-react";

export default function ViewOnly(props) {
  const { systems } = props;

  if (!systems.length) {
    return (
      <Segment padded textAlign="center">
        <h2>No systems found for this contract.</h2>
      </Segment>
    );
  }

  return (
    <Segment>
      <Table size="large">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell content="System" />
            {/* <Table.HeaderCell content="Price" /> */}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {systems.map((sys, i) => (
            <Table.Row key={i}>
              <Table.Cell content={sys.name} />
              {/* <Table.Cell content={`${sys.price_formatted}`} /> */}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Segment>
  );
}
